import React from "react";
import { Badge } from "./ui/badge";
import { Card, CardContent } from "./ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./ui/tabs";
import { CheckCircle2 } from "lucide-react";
import { tips } from "../data/mock";

const Tips = () => {
  return (
    <section id="tips" className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <Badge className="bg-green-50 text-green-700 border border-green-200 hover:bg-green-50 mb-4">Pass the First Time</Badge>
          <h2 className="text-3xl md:text-5xl font-black text-slate-900 tracking-tight">Tips to help you pass a smog check</h2>
          <p className="text-slate-600 mt-4 text-lg">Simple pre-inspection steps recommended by our STAR-certified technicians.</p>
        </div>

        <Tabs defaultValue="modern" className="max-w-4xl mx-auto">
          <TabsList className="grid grid-cols-2 w-full h-12 bg-slate-100 mb-8">
            <TabsTrigger value="modern" className="font-bold data-[state=active]:bg-white data-[state=active]:text-green-600">Vehicles 1996 &amp; Newer</TabsTrigger>
            <TabsTrigger value="classic" className="font-bold data-[state=active]:bg-white data-[state=active]:text-green-600">Classic 1976 – 1995</TabsTrigger>
          </TabsList>
          <TabsContent value="modern">
            <Card className="border-slate-200">
              <CardContent className="p-8">
                <ul className="space-y-4">
                  {tips.modern.map((t, i) => (
                    <li key={i} className="flex gap-3">
                      <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 leading-relaxed">{t}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </TabsContent>
          <TabsContent value="classic">
            <Card className="border-slate-200">
              <CardContent className="p-8">
                <ul className="space-y-4">
                  {tips.classic.map((t, i) => (
                    <li key={i} className="flex gap-3">
                      <CheckCircle2 className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                      <span className="text-slate-700 leading-relaxed">{t}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </TabsContent>
        </Tabs>

        <p className="text-xs text-slate-500 text-center mt-6 max-w-2xl mx-auto">
          Disclaimer: These are general suggestions intended to improve the probability of passing a smog check. They are not all-inclusive and do not guarantee that your vehicle will pass solely by following them.
        </p>
      </div>
    </section>
  );
};

export default Tips;
